import { ObjectValidator } from '@leverege/object-validator';
import AttributeObjectValidators from "./AttributeObjectValidators.js";
import AttributeValueValidators from "./AttributeValueValidators.js";
export default class AttributeObjectValidator extends ObjectValidator {
  constructor(options) {
    const {
      attributes,
      object,
      context
    } = options;
    const objectValidators = AttributeObjectValidators.getValidatorsFor({
      objectType: object?.type,
      ...context
    });
    const fields = attributes.reduce((prev, attr) => {
      if (attr?.name) {
        const valueValidators = AttributeValueValidators.getValidatorsFor(attr.name, object);
        if (valueValidators) {
          prev[attr.name] = {
            name: attr.displayName,
            valueValidator: valueValidators?.map(validator => validator.valueValidator).filter(val => val != null),
            labelDecorator: valueValidators?.map(validator => validator.labelDecorator).filter(val => val != null)
          };
        }
      }
      return prev;
    }, {});
    super({
      fields,
      objectValidators
    });
  }
}